/**
 * HubSpot "updated" forms render inside iframes. Parent-page CSS does not apply,
 * but same-origin iframes allow injecting our rules into the frame document.
 */
(() => {
  const STYLE_ID = 'kobho-hs-form-styles';

  const getHubspotCssText = () => {
    for (const sheet of document.styleSheets) {
      if (!sheet.href || !/hubspot-form/.test(sheet.href)) continue;
      try {
        return [...sheet.cssRules].map((rule) => rule.cssText).join('\n');
      } catch (error) {
        // ignore unreadable sheets
      }
    }
    return '';
  };

  let cachedCssText = '';

  const styleIframe = (iframe) => {
    try {
      const doc = iframe.contentDocument;
      if (!doc || !doc.head) return false;
      if (doc.getElementById(STYLE_ID)) return true;

      if (!cachedCssText) cachedCssText = getHubspotCssText();
      if (!cachedCssText) return false;

      const style = doc.createElement('style');
      style.id = STYLE_ID;
      style.textContent = cachedCssText;
      doc.head.appendChild(style);
      return true;
    } catch (error) {
      return false;
    }
  };

  const styleAll = () => {
    document.querySelectorAll('iframe.hs-form-iframe').forEach(styleIframe);
  };

  styleAll();

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (!(node instanceof Element)) continue;
        if (node.matches?.('iframe.hs-form-iframe')) styleIframe(node);
        node.querySelectorAll?.('iframe.hs-form-iframe').forEach(styleIframe);
      }
    }
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });

  // HubSpot often paints the form a moment after the iframe appears.
  const intervalId = window.setInterval(styleAll, 500);
  window.setTimeout(() => window.clearInterval(intervalId), 20000);
})();
